<template>
  <div class="LKMunMehFormFourLevels">
    <div
      v-for="(level, idx) in parent.items"
      :key="level.id"
      :ref="`SubIndicator.${level.id}`"
      :class="{ 'LKMunMehReviewFourLevels__Level__Selected': $route.params.targetId === level.id }"
      class="LKMunMehFormFourLevels__Level"
    >
      <LKMunMehFormRow
        class="LKMunMehFormFourLevels__Level__Row"
        :idx="getIndex(idx)"
        :item="level"
      />

      <LKMunMehFormDocuments
        :ref="`Documents.${idx}`"
        :key="idx"
        :third-level-id="parent.id"
        :fourth-level-id="level.id"
        :mun-meh-id="munMehId"
        :disabled="disabled"
      />
    </div>
  </div>
</template>

<script>
import LKMunMehFormRow from '@/views/LKMunMeh/Form/components/LKMunMehFormRow.vue'

import LKMunMehFormDocuments from '@/views/LKMunMeh/Form/components/LKMunMehFormDocuments.vue'

export default {
  name: 'LKMunMehFormFourLevels',
  $_veeValidate: {
    /** @type 'new' */
    validator: 'new',
  },
  components: {
    LKMunMehFormRow,
    LKMunMehFormDocuments,
  },
  props: {
    munMehId: {
      type: Number,
      required: true,
    },
    parent: {
      type: Object,
      required: true,
    },
    parentIdx: {
      type: String,
      required: true,
    },
    disabled: Boolean,
  },
  methods: {
    scrollToTarget(_targetId) {
      const targetId = _targetId || this.$route.params?.targetId
      if (targetId) {
        const elements = this.$refs[`SubIndicator.${targetId}`]
        if (Array.isArray(elements) && elements.length > 0) {
          this.$nextTick(() => {
            setTimeout(() => elements[0].scrollIntoView(), 100)
          })
        }
      }
    },
    getIndex(idx) {
      return [this.parentIdx, idx].join('.')
    },
    async validate() {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < this.parent.items.length; i++) {
        const idx = `Documents.${i}`
        // eslint-disable-next-line no-await-in-loop
        const result = await this.$refs[idx][0].validate()
        if (!result) {
          return false
        }
      }
      return true
    },
  },
}
</script>

<style lang="scss">
.LKMunMehFormFourLevels {
  &__Level {
    &__Row {
      // ..
    }
  }
}
</style>
